const ClassBannersAvailableCategories = ({ classBannerCategories }) => {
  const classBannerCategoriesContent = classBannerCategories.map((classBannerCategory) => {
    return (
      <div
        key={classBannerCategory.id}
        className="px-[16px] py-[10px] bg-[#FDFDFD] rounded-[6px] text-sm leading-[20px] font-bold text-primary-100"
      >
        {classBannerCategory.name}
      </div>
    )
  })

  return (
    <div className="w-full border-[#F79009] border-[1px] rounded-[10px] p-[20px]">
      <span className="text-sm font-normal text-primary-100">
        You have {classBannerCategories.length}{' '}
        {classBannerCategories.length > 1 ? 'categories' : 'category'} available
        {classBannerCategories.length ? ':' : ''}
      </span>

      {!!classBannerCategories.length && (
        <div className="w-full mt-[10px] flex items-start flex-wrap gap-[8px]">
          {classBannerCategoriesContent}
        </div>
      )}
    </div>
  )
}

export default ClassBannersAvailableCategories
